<template>
  <div class="screen-fit">
    <div
      class="screen-fit__canvas"
      :style="canvasStyle"
    >
      <slot />
    </div>
  </div>
</template>

<script>
const DESIGN_WIDTH = 2489;
const DESIGN_HEIGHT = 1242;

export default {
  name: "ScreenFit",
  data() {
    return {
      scale: 1,
      offsetX: 0,
      offsetY: 0
    };
  },
  computed: {
    canvasStyle() {
      return {
        width: `${DESIGN_WIDTH}px`,
        height: `${DESIGN_HEIGHT}px`,
        "--screen-width": `${DESIGN_WIDTH}px`,
        "--screen-height": `${DESIGN_HEIGHT}px`,
        "--screen-dialog-max-height": `${Math.round(DESIGN_HEIGHT * 0.7)}px`,
        transform: `translate(${this.offsetX}px, ${this.offsetY}px) scale(${this.scale})`
      };
    }
  },
  mounted() {
    this.updateScale();
    window.addEventListener("resize", this.updateScale);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScale);
  },
  methods: {
    updateScale() {
      const viewportWidth = window.innerWidth || DESIGN_WIDTH;
      const viewportHeight = window.innerHeight || DESIGN_HEIGHT;
      const scale = Math.min(viewportWidth / DESIGN_WIDTH, viewportHeight / DESIGN_HEIGHT);

      this.scale = scale;
      this.offsetX = Math.max((viewportWidth - DESIGN_WIDTH * scale) / 2, 0);
      this.offsetY = Math.max((viewportHeight - DESIGN_HEIGHT * scale) / 2, 0);
    }
  }
};
</script>

<style lang="less" scoped>
.screen-fit {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #020816;
}

.screen-fit__canvas {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: left top;
  overflow: hidden;
}
</style>
